'use client';

import { Children, cloneElement, forwardRef, isValidElement, useContext, useMemo } from 'react';

import { css, cx } from '@/styled-system/css';

import { ToastContext } from './context/toast.context';
import { toastCloseStyles } from './styles/toast-close.styles';
import type { ToastClosePropsInterface } from './types/toast-close.types';

export const ToastClose = forwardRef<HTMLDivElement, ToastClosePropsInterface>(
  (props: ToastClosePropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    const { handleClose } = useContext(ToastContext);

    const styles = css(toastCloseStyles, cssProp);

    const content = useMemo(() => {
      const child = Children.toArray(children).at(0);

      if (!isValidElement(child)) {
        return null;
      }

      return cloneElement<any>(child, {
        onClick: (e: any) => {
          child.props.onClick?.(e);
          handleClose?.();
        },
      });
    }, [children, handleClose]);

    return (
      <div
        className={cx('c11n', 'c11n_toast__close', styles, className)}
        data-c11n-component="Toast.Close"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      >
        {content}
      </div>
    );
  },
);

ToastClose.displayName = 'Toast.Close';
